import React, { ReactNode } from 'react';
import { ShoppingCartProvider } from './shoppingcart.provider';
import { NavigationGuardProvider } from './navigationguard.provider';
import { CheckoutProvider } from './checkout.provider';

interface ProvidersProps {
  children: ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  return (
    <ShoppingCartProvider>
      <CheckoutProvider>
        <NavigationGuardProvider>{children}</NavigationGuardProvider>
      </CheckoutProvider>
    </ShoppingCartProvider>
  );
}
